import React from 'react';
import { Link } from 'react-router-dom';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-page">
      <div className="privacy-container">
        <div className="privacy-content">
          {/* Header */}
          <div className="privacy-header">
            <h1 className="privacy-title">
              <i className="fas fa-shield-alt"></i>
              Privacy Policy & Terms of Usage
            </h1>
            <div className="privacy-meta">
              <p><strong>Effective Date:</strong> January 1, 2024</p>
              <p><strong>Platform:</strong> <a href="https://nivaas.app/" target="_blank" rel="noopener noreferrer">https://nivaas.app/</a></p>
              <p><strong>Provider:</strong> Kudosta Solutions LLP</p>
            </div>
          </div>

          {/* Privacy Policy Section */}
          <section className="privacy-section">
            <h2 className="section-title">
              <i className="fas fa-lock"></i>
              Privacy Policy
            </h2>

            <div className="subsection">
              <h3>1. Data Collection</h3>
              <p>We collect and store the following data types for society management purposes:</p>
              <ul>
                <li>Personal details (name, email, phone, role)</li>
                <li>Visitor records (names, check-in/out, unit visited)</li>
                <li>Maintenance complaints</li>
                {/* <li>Financial transactions (expenses, payments)</li> */}
                <li>System and activity logs</li>
              </ul>
            </div>

            <div className="subsection">
              <h3>2. Purpose of Data Use</h3>
              <p>Your data is used to:</p>
              <ul>
                <li>Facilitate efficient society administration</li>
                <li>Improve communication between residents and staff</li>
                <li>Maintain a secure and transparent record-keeping system</li>
              </ul>
            </div>

            <div className="subsection">
              <h3>3. Data Retention Policy</h3>
              <p>To keep our system efficient and protect your privacy:</p>
              <ul>
                <li>Visitor records, complaints, and logs are stored for up to 3 months</li>
                <li>Financial data is retained for a maximum of 3 years</li>
              </ul>
              <div className="alert alert-warning">
                <i className="fas fa-exclamation-triangle"></i>
                <strong>Important:</strong> After this period, data is automatically deleted and cannot be recovered.
                Users are advised to download and store any important data regularly.
              </div>
            </div>

            <div className="subsection">
              <h3>4. Exporting Your Data</h3>
              <p>We provide built-in tools that allow users (especially Admins and Owners) to export:</p>
              <ul>
                <li>Financial summaries and reports</li>
                <li>Visitor and complaint logs</li>
                {/* <li>Dues and payment histories</li> */}
              </ul>
              <div className="alert alert-info">
                <i className="fas fa-info-circle"></i>
                Please ensure you export your data within the retention window.
              </div>
            </div>

            <div className="subsection">
              <h3>5. Data Sharing & Third Parties</h3>
              <p>We do not share your personal or society data with third parties unless:</p>
              <ul>
                <li>Required by law</li>
                <li>You provide explicit consent</li>
              </ul>
            </div>

            <div className="subsection">
              <h3>6. Security Measures</h3>
              <ul>
                <li>Encrypted data storage</li>
                <li>JWT-secured authentication</li>
                <li>Role-based access</li>
                <li>Activity logging and IP-level monitoring</li>
              </ul>
            </div>
          </section>

          {/* Terms of Usage Section */}
          <section className="privacy-section">
            <h2 className="section-title">
              <i className="fas fa-file-contract"></i>
              Terms of Usage
            </h2>

            <div className="subsection">
              <h3>1. User Responsibilities</h3>
              <p>By using nivaas.app, you agree to:</p>
              <ul>
                <li>Use the platform solely for society-related tasks</li>
                <li>Maintain truthful and accurate records</li>
                <li>Respect access levels and permissions</li>
              </ul>
            </div>

            <div className="subsection">
              <h3>2. Roles & Permissions</h3>
              <p>Features are assigned based on user roles:</p>
              <ul>
                {/* <li><strong>SuperAdmin:</strong> Global access across all societies</li>
                <li><strong>Org Admin:</strong> Control within their own society</li> */}
                <li><strong>Owner:</strong> Personal financial and complaint view</li>
                <li><strong>Guard/Maintenance:</strong> Operational logging, restricted data access</li>
              </ul>
            </div>

            <div className="subsection">
              <h3>3. Suspension/Termination</h3>
              <p>Accounts may be suspended for:</p>
              <ul>
                <li>Malicious activity</li>
                <li>Repeated abuse of access</li>
                <li>Violation of these terms or community trust</li>
              </ul>
            </div>

            <div className="subsection">
              <h3>4. Changes to Policy</h3>
              <p>
                We may update this policy to reflect improvements or legal requirements.
                Changes will be communicated via email or in-app notices.
              </p>
            </div>
          </section>

          {/* Contact Section */}
          <section className="privacy-section">
            <h2 className="section-title">
              <i className="fas fa-envelope"></i>
              Contact Us
            </h2>
            <div className="contact-section">
              <p>For support, questions, or data-related concerns, please contact:</p>
              <div className="contact-details">
                <div className="contact-item">
                  <i className="fas fa-headset"></i>
                  <strong>Support Page:</strong>
                  <Link to="/support">Submit a Support Ticket</Link>
                </div>
                <div className="contact-item">
                  <i className="fas fa-envelope"></i>
                  <strong>Email:</strong>
                  <a href="mailto:support@nivaas.app">support@nivaas.app</a>
                </div>
                <div className="contact-item">
                  <i className="fas fa-building"></i>
                  <strong>Business Entity:</strong>
                  <span>Kudosta Solutions LLP</span>
                </div>
                <div className="contact-item">
                  <i className="fas fa-globe"></i>
                  <strong>Website:</strong>
                  <a href="https://nivaas.app" target="_blank" rel="noopener noreferrer">https://nivaas.app</a>
                </div>
              </div>
            </div>
          </section>

          {/* Footer Navigation */}
          <div className="privacy-footer">
            <Link to="/" className="btn btn-outline">
              <i className="fas fa-home"></i>
              Back to Home
            </Link>
            <Link to="/login" className="btn btn-primary">
              <i className="fas fa-sign-in-alt"></i>
              Login to Platform
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 